<script setup lang="ts">
const { folder, file } = defineProps<{
  folder: 'graphics' | 'icons' | 'images'
  file: string
}>()

const src = usePublicAssetUrl(`/${folder}/${file}`)
</script>

<template>
  <img :src="src" alt="" />
</template>
